export var LOADER_SIZES;
(function (LOADER_SIZES) {
  LOADER_SIZES[LOADER_SIZES["xxs"] = 12] = "xxs";
  LOADER_SIZES[LOADER_SIZES["xs"] = 15] = "xs";
  LOADER_SIZES[LOADER_SIZES["s"] = 18] = "s";
  LOADER_SIZES[LOADER_SIZES["m"] = 24] = "m";
  LOADER_SIZES[LOADER_SIZES["l"] = 48] = "l";
})(LOADER_SIZES || (LOADER_SIZES = {}));